module.exports = __webpack_public_path__ + "img/auction-2.a829e502.png";